export interface App {
    id: number;
    name: string;
    details: string;
}

export enum AppsName {
    SG = 'MODULE_SCHEDULEGENIE',
    CM = 'MODULE_CONCESSIONMANAGER',
    CU = 'MODULE_CALLUS',
    BPN = 'MODULE_BPN',
    IC = 'MODULE_INCOMECALCULATOR',
    CH = 'MODULE_CHAT',
    CB = 'MODULE_CHATBOT',
    TU = 'MODULE_TEXTUS',
    FS = 'MODULE_INSITE'
}
